export type TotalSubscriptions = {
  totalBooster: number;
  totalBusiness: number;
  totalFamily: number;
  totalImpactOnly: number;
  totalMega: number;
  totalPersonal: number;
};

export type Totals = {
  totalCarbon: number;
  totalTrees: number;
} & TotalSubscriptions;
